<template>
  <el-row :gutter="20">
    <el-col :lg="16" :md="12">
      <el-card shadow="never" class="box-card">
        <el-row>
          <template v-for="(form, idx) in forms">
            <el-col :span="12" :key="idx">
              <el-form-item
                v-if="(idx >= 0 && idx <= 2) || idx == 10"
                size="small"
                :prop="form.id"
                :label="form.label"
                :rules="form.rules"
              >
                <el-col :span="20">
                  <el-input
                    v-model="Product[form.id]"
                    :disabled="form.disabled"
                    :type="form.type"
                    :placeholder="`Please input ${form.label}`"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </template>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              size="small"
              :prop="forms[3].id"
              :label="forms[3].label"
              :rules="forms[3].rules"
            >
              <el-col :span="20">
                <el-input
                  v-model="Product[forms[3].id]"
                  :disabled="forms[3].disabled"
                  :type="forms[3].type"
                  :placeholder="`Please input ${forms[3].label}`"
                ></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item
              size="small"
              :prop="forms[4].id"
              :label="forms[4].label"
              :rules="forms[4].rules"
            >
              <el-col :span="24">
                <el-input
                  v-model="Product[forms[4].id]"
                  :disabled="forms[4].disabled"
                  :type="forms[4].type"
                  :placeholder="`Please input ${forms[4].label}`"
                ></el-input>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>Tags</el-col>
          <el-col>
            <el-tag>{{ Product.data || "-" }}</el-tag>
          </el-col>
        </el-row>

        <el-row class="mt-4">
          <template v-for="(form, idx) in forms">
            <el-col :span="12" :key="idx">
              <el-form-item
                v-if="idx >= 5 && idx < 10"
                size="small"
                :key="idx"
                :prop="form.id"
                :label="form.label"
                :rules="form.rules"
              >
                <el-col :span="20">
                  <el-select
                    v-if="idx === 6"
                    v-model="Product[form.id]"
                    :placeholder="`Please select ${form.label}`"
                    ref="kategoriId"
                    style="width: 100%"
                    filterable
                    remote
                    :remote-method="onSearchCategory"
                    :loading="categories.isLoading"
                  >
                    <el-option
                      v-for="item in form.data"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                    <el-row type="flex" justify="center">
                      <el-button
                        :loading="categories.isLoading"
                        size="mini"
                        round
                        @click="loadMoreCategory"
                      >Load More</el-button>
                    </el-row>
                  </el-select>
                  <el-select
                    v-else-if="idx === 7"
                    v-model="Product[form.id]"
                    :placeholder="`Please select ${form.label}`"
                    style="width: 100%"
                    filterable
                    remote
                    :remote-method="onSearchBrand"
                    :loading="brands.isLoading"
                  >
                    <el-option
                      v-for="item in form.data"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                    <el-row type="flex" justify="center">
                      <el-button
                        :loading="brands.isLoading"
                        size="mini"
                        round
                        @click="loadMoreBrand"
                      >Load More</el-button>
                    </el-row>
                  </el-select>
                  <el-select
                    v-else
                    style="width: 100%"
                    v-model="Product[form.id]"
                    :disabled="form.disabled"
                    :placeholder="`Please select ${form.label}`"
                  >
                    <el-option
                      v-for="item in form.data"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="Check Stock" prop="active">
              <el-switch v-model="Product.checkStock"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-col>

    <el-col :lg="8" :md="12">
      <el-card class="box-card" shadow="never">
        <span>Picture</span>
        <el-image style="width: 100%; height: 260px" :src="Product.picture" fit="cover"></el-image>
        <input
          style="display: none"
          type="file"
          placeholder="Please Input Payment Note"
          ref="fileInputPicture"
          accept="image/*"
          @change="e => onFilePicked(e, 'picture')"
        />

        <el-row type="flex" justify="end" class="mt-2">
          <el-col :span="12">
            <el-button
              type="primary"
              size="small"
              @click="onPickFile('picture')"
              style="width: 100%"
            >Upload</el-button>
          </el-col>
        </el-row>
        <span class="mt-2">Thumbnail</span>
        <el-image style="width: 100%; height: 260px" :src="Product.thumbnail" fit="cover"></el-image>
        <input
          style="display: none"
          type="file"
          placeholder="Please Input Payment Note"
          ref="fileInputThumbnail"
          accept="image/*"
          @change="e => onFilePicked(e, 'thumbnail')"
        />

        <el-row type="flex" justify="end" class="mt-2">
          <el-col :span="12">
            <el-button
              type="primary"
              size="small"
              @click="onPickFile('thumbnail')"
              style="width: 100%"
            >Upload</el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
    <el-col class="mt-2">
      <el-card class="box-card" shadow="never">
        <el-table
          :data="Product.priceDetails.rows"
          border
          empty-text="Tidak ada data"
          style="width: 100%"
        >
          <el-table-column type="index" label="No" width="50"></el-table-column>
          <el-table-column prop="price.customerClassCode" label="Customer Class"></el-table-column>
          <el-table-column prop="price.customerType" label="Customer Type"></el-table-column>
          <el-table-column prop="price.branchCode" label="Branch"></el-table-column>
          <el-table-column prop="uomCode" label="UOM Code"></el-table-column>
          <el-table-column prop="itemPrice" label="Price"></el-table-column>
          <el-table-column sortable prop="price.isRetur" label="Retur" width="180">
            <template slot-scope="scope">
              <p v-if="scope.row.price.isRetur === true" effect="dark">True</p>
              <p v-else-if="scope.row.price.isRetur === false" type="warning" effect="dark">False</p>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
          <el-pagination
            layout="prev, pager, next"
            :total="Product.priceDetails.count"
            :current-page="parseInt(page)"
            @current-change="
              e => {
                toAnotherPage(e),  settingTable(e);
              }
            "
            :page-size="100"
          ></el-pagination>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
  
</template>

<script>
import { mapActions, mapState } from "vuex";
import S3Client from "../../../common/S3/S3Client";
import configS3 from "../../../common/S3/configS3";

export default {
  props: ["Product"],
  data() {
    return {
      image: null,
      limitCategory: 25,
      limitBrand: 25,
      searchCategory: '',
    };
  },
  methods: {
    ...mapActions({
      getCategory: "category/GetCategorys",
      getBrand: "brand/GetBrands",
      getPrincipal: "principal/GetPrincipals",
      GetProductQuery: "product/GetProductQuery",
    }),
    onSearchCategory(search) {
      this.searchCategory = search;
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getCategory(option);
    },
    loadMoreCategory() {
      this.$refs.kategoriId[0].focus();
      this.limitCategory += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitCategory,
          search: this.searchCategory
        }
      };
      this.getCategory(option);
    },
    onSearchBrand(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getBrand(option);
    },
    loadMoreBrand() {
      this.limitBrand += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitBrand,
        }
      };
      this.getBrand(option);
    },
    onPickFile(type) {
      if (type === "picture") {
        this.$refs.fileInputPicture.click();
      } else if (type === "thumbnail") {
        this.$refs.fileInputThumbnail.click();
      }
    },
    async onFilePicked(event, type) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }
      const fileReader = new FileReader();
      const config = configS3(
        "fastmart-image",
        `${process.env.NODE_ENV}/product`
      );
      const file = await S3Client.uploadFile(files[0], config);
      fileReader.addEventListener("load", () => {
        if (type === "picture") {
          this.Product.picture = file.location;
        } else if (type === "thumbnail") {
          this.Product.thumbnail = file.location;
        }
      });
      fileReader.readAsDataURL(files[0]);
    },
    settingTable(e) {
      let option = {
        id: this.Product.oracleItemId,
        params: {
          page: e,
          limit: 100,
        }
      };
      this.GetProductQuery(option);
    },
    toAnotherPage(page) {
      this.$router.push({
        path: `/product/edit/${this.Product.oracleItemId}`,
        query: { page: page, limit: 100 }
      });
    },
  },
  computed: {
    ...mapState({
      categories: state => state.category.categories,
      brands: state => state.brand.brands,
      principals: state => state.principal.principals
    }),
    forms() {
      return [
        {
          type: "text",
          id: "oracleItemId",
          label: "Oracle Item ID",
          disabled: true,
          rules: []
        },
        {
          type: "text",
          id: "itemCode",
          label: "Item Code",
          disabled: true,
          rules: []
        },
        {
          type: "text",
          id: "barcode",
          label: "Barcode",
          disabled: false,
          rules: []
        },
        {
          type: "text",
          id: "itemName",
          label: "Item Name",
          disabled: true,
          rules: []
        },
        {
          type: "textarea",
          id: "description",
          label: "Description",
          disabled: false,
          rules: []
        },
        {
          type: "select",
          id: "itemType",
          label: "Item Type",
          disabled: true,
          rules: [],
          data: [
            {
              name: "Inventory",
              value: "inventory"
            },
            {
              name: "Non Inventory",
              value: "non inventory"
            },
            {
              name: "Grouping",
              value: "grouping"
            }
          ],
          multi: false
        },
        {
          type: "select",
          id: "kategoriId",
          label: "Category",
          disabled: false,
          rules: [],
          data: this.categories.data.map(item => {
            item.name = item.categoryName;
            item.value = item.id;
            return item;
          }),
          multi: false
        },
        {
          type: "select",
          id: "brandId",
          label: "Brand",
          disabled: false,
          rules: [],
          data: this.brands.data.map(item => {
            item.name = `${item.brandCode} - ${item.brandName}`;
            item.value = item.id;
            return item;
          }),
          multi: false
        },
        {
          type: "select",
          id: "principalId",
          label: "Principal",
          disabled: true,
          rules: [],
          data: this.principals.data.map(item => {
            item.name = item.principalName;
            item.value = item.id;
            return item;
          }),
          multi: false
        },
        // {
        //   type: "select",
        //   id: "defaultUomCode",
        //   label: "Default UOM",
        //   disabled: false,
        //   rules: [],
        //   data:
        //     this.Product.priceDetails &&
        //     this.Product.priceDetails.rows &&
        //     [],
        //   multi: false
        // },
        {
          type: "text",
          id: "oracleItemCode",
          label: "Oracle Item Code",
          disabled: true,
          rules: []
        },
      ];
    }
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 100
      }
    };
    this.getBrand(option);
    this.getCategory(option);
    this.getPrincipal(option);
    this.page = this.$router.history.current.query.page;
  }
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
